import type { Cta, Maybe } from '@/graphql/generated/types';

export const getCtaLink = (
  cta: Maybe<Cta> | undefined,
): Maybe<string> | undefined => {
  if (!cta || !cta.linkToPage) return undefined;
  switch (cta.linkToPage?.__typename) {
    case 'PlpPage':
      return `/collections/${cta.linkToPage?.urlKey}`;
    case 'Page':
      return `/${cta.linkToPage?.slug}`;
    default:
      return undefined;
  }
};
